// Version : 0.0.2
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'REMOVE UNUSED LINES'
// Modified Date : 06/12/2025
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET ALL LOAN INDEX LIST START *********************** */
export const fetchGoldLoanIndexDisbursement = (encodeData: any) => {
	const data = {
		FetchGoldLoanIndexDetailToken: encodeData,
	};
	const url = `${API_URL}fetchGoldLoanIndexDetail`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL LOAN INDEX LIST END *********************** */

/** ***************** GET ALL LOAN INDEX LIST BASED ON GROUP START *********************** */
export const fetchGoldLoanIndexDisbursementList = (encodeData: any) => {
	const data = {
		GoldLoanIndexListGroupToken: encodeData,
	};
	const url = `${API_URL}getGoldLoanIndexListGroup`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL LOAN INDEX LIST BASED ON GROUP END *********************** */

/** ***************** UPDATE GOLD LOAN DISBURSEMENT START *********************** */
export const updateGoldLoanDisbursement = (encodeData: any) => {
	const data = {
		UpdateGoldLoanDisbursementToken: encodeData,
	};
	const url = `${API_URL}updateGoldLoanDisbusrsement`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GOLD LOAN DISBURSEMENT END *********************** */
